import BaseHistoryRecordModel from '../BaseHistoryRecordModel';
import { HistoryRecordDto } from '../../services/types';

export default class CustomRoleAssignmentHistoryRecordModel extends BaseHistoryRecordModel {
    constructor(data: HistoryRecordDto) {
        super(data);

        const userName = this.fields.find(field => field.name === 'UserName')?.value;

        if (typeof userName === 'string') {
            this.setDisplayName(userName);
        }
    }

    get objectLabel() {
        return 'Role Assignment';
    }
}
